export const relativePositionAffixes = [
  'prev-prev',
  'prev',
  'active',
  'next',
  'next-next'
] as const;

const alignmentOptions: Record<string, string> = {
  left: 'flex-start',
  right: 'flex-end',
  center: 'center'
};

export function alignToJustifyContent(
  settingsAlign: string,
  withCenter = false
) {
  const justifyValue = alignmentOptions[settingsAlign];

  if (justifyValue && (justifyValue !== 'center' || withCenter)) {
    return justifyValue;
  }

  return '';
}
